export default "__VITE_ASSET__DnfK7jf1__"